/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLeaderboardNicknameResponse
 */
export interface GetLeaderboardNicknameResponse {
    /**
     * 
     * @type {string}
     * @memberof GetLeaderboardNicknameResponse
     */
    nickname: string;
}

/**
 * Check if a given object implements the GetLeaderboardNicknameResponse interface.
 */
export function instanceOfGetLeaderboardNicknameResponse(value: object): value is GetLeaderboardNicknameResponse {
    if (!('nickname' in value) || value['nickname'] === undefined) return false;
    return true;
}

export function GetLeaderboardNicknameResponseFromJSON(json: any): GetLeaderboardNicknameResponse {
    return GetLeaderboardNicknameResponseFromJSONTyped(json, false);
}

export function GetLeaderboardNicknameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeaderboardNicknameResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nickname': json['nickname'],
    };
}

export function GetLeaderboardNicknameResponseToJSON(json: any): GetLeaderboardNicknameResponse {
    return GetLeaderboardNicknameResponseToJSONTyped(json, false);
}

export function GetLeaderboardNicknameResponseToJSONTyped(value?: GetLeaderboardNicknameResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nickname': value['nickname'],
    };
}

